<mat-card>
    <ul class="breadcrumbs">
        <li *ngFor="let breadcrumb of breadcrumbs;let last = last" class="breadcrumb-item" [ngClass]="{active: last}">
            <a *ngIf="!last" [routerLink]="breadcrumb.url">{{breadcrumb.title}}</a>
            <span *ngIf="last">{{breadcrumb.title}}</span>
        </li>
    </ul>
</mat-card>
